import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useVideosListingStore, { setVideosSearch, updateVideosFilters } from 'layout/Listing/variants/videos/store';

const useVideoFilterSearchParam = () => {
  const router = useRouter();
  const activeFilters = useVideosListingStore(state => state.filters);
  const activeSearch = useVideosListingStore(state => state.search);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get('s');
    const category = params.get('category');

    if (search) {
      setVideosSearch(search);
    }

    if (category && activeFilters === 'All') {
      updateVideosFilters(router, category);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (activeSearch) {
      params.set('s', activeSearch);
    } else {
      params.delete('s');
    }

    const basePath = router.asPath.split('?')[0];
    const newUrl = `${basePath}?${params.toString()}`;
    router.replace(newUrl, undefined, { shallow: true, scroll: false });
  }, [activeSearch]);
};

export default useVideoFilterSearchParam;
